import ChangeTentativeExit from './ChangeTentativeExit';

export default ChangeTentativeExit;
